export default function ({app, error}) {
  if (!app.$planHasPermission('manage_group_user')) {
    return error({
      message: '権限がありません。',
      redirectPath: app.$redirectPathDefault(),
      redirectText: 'メインメニュー'
    });
  }
}
